<template>
    <div class="search_pull_downs">
        <CustomPullDown
                caption="見本帳で検索"
                :items="sample_book_tag_names"
                :checked_items="checked_sample_book_tag"
                @change="setSelectedSampleBook"
                style="z-index: 100000"
        />
        <CustomPullDown
                caption="部屋別で検索"
                :items="room_tag_names"
                :checked_items="checked_room_tag"
                @change="setSelectedRoom"
                style="z-index: 100000"
        />
        <CustomPullDown
                caption="床色で検索"
                :items="floor_tag_names"
                :checked_items="checked_floor_tag"
                @change="setSelectedFloor"
        />
        <CustomPullDown
                caption="スタイルで検索"
                :items="style_tag_names"
                :checked_items="checked_style_tag"
                @change="setSelectedStyle"
        />
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import Ajax from '../assets/js/Ajax'
    import Util from '../assets/js/Util'
    import CustomPullDown from './CustomPullDown'

    export default {
        name: "SearchPullDowns",
        components: { CustomPullDown },
        data: () => ({
            style_tags: [],
            room_tags: [],
            floor_tags: [],
            sample_book_tags: [],
        }),
        computed: {
            ...mapState('search', ['search_conditions', 'search_text']),
            style_tag_names: _this => _this.style_tags.map(tag => tag.name_ja),
            room_tag_names: _this => _this.room_tags.map(tag => tag.name_ja),
            floor_tag_names: _this => _this.floor_tags.map(tag => tag.name_ja),
            sample_book_tag_names: _this => _this.sample_book_tags.map(tag => tag.name_ja),
            checked_style_tag: _this => _this.search_conditions.filter(tag => tag.category === 'style').map(tag => tag.name_ja),
            checked_room_tag: _this => _this.search_conditions.filter(tag => tag.category === 'room').map(tag => tag.name_ja),
            checked_floor_tag: _this => _this.search_conditions.filter(tag => tag.category === 'floor').map(tag => tag.name_ja),
            checked_sample_book_tag: _this => _this.search_conditions.filter(tag => tag.category === 'sample_book').map(tag => tag.name_ja),
        },
        async created() {
            const {style, room, floor, sample_book} = await Ajax.getSearchTags();
            this.style_tags = style;
            this.room_tags = room;
            this.floor_tags = floor;
            this.sample_book_tags = sample_book;
        },
        methods: {
            ...mapMutations('search', ["setSearchConditions"]),
            setSelectedStyle(tags) {
                const current_tags_without_style_tag = this.search_conditions.filter(t => t.category !== 'style').map(t => t.name_ja);
                const tags_ja = [...current_tags_without_style_tag, ...tags];
                this.emitSearchConditions(tags_ja);
            },
            setSelectedRoom(tags) {
                const current_tags_without_room_tag = this.search_conditions.filter(t => t.category !== 'room').map(t => t.name_ja);
                const tags_ja = [...current_tags_without_room_tag, ...tags];
                this.emitSearchConditions(tags_ja);
            },
            setSelectedFloor(tags) {
                const current_tags_without_floor_tag = this.search_conditions.filter(t => t.category !== 'floor').map(t => t.name_ja);
                const tags_ja = [...current_tags_without_floor_tag, ...tags];
                this.emitSearchConditions(tags_ja);
            },
            setSelectedSampleBook(tags) {
                const current_tags_without_sample_book_tag = this.search_conditions.filter(t => t.category !== 'sample_book').map(t => t.name_ja);
                const tags_ja = [...current_tags_without_sample_book_tag, ...tags];
                this.emitSearchConditions(tags_ja);
            },
            async emitSearchConditions(tags_ja) {
                const tag_data = await Ajax.getTagData();
                const tags = tags_ja
                    .map(tag => tag_data.find(t => t.name_ja === tag))
                    .filter(d => d);
                this.setSearchConditions(tags);
                const query_param = Util.generateQueryParam('tags[]', tags_ja, this.search_text);

                await this.$router.push('/?' + query_param);
            },
        }
    }
</script>

<style scoped lang="scss">
    .search_pull_downs{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1rem;
        width: 450px;
        > *:not(last-child) {
            margin-right: 1rem;
            margin-bottom: 0.5rem;
        }
    }
</style>
